import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  items: [],
};

export default function documentSubTypesByDocumentTypeReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case types.DOCUMENT_SUB_TYPES_BY_DOCUMENT_TYPE_INIT:
      return { ...state, error: null, isLoading: true };

    case types.DOCUMENT_SUB_TYPES_BY_DOCUMENT_TYPE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        items: action.data.data,
        error: action.data.error,
      };

    case types.DOCUMENT_SUB_TYPES_BY_DOCUMENT_TYPE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
